import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" className="site-header-logo">
          <img
            src="/images/logo.png"
            alt="How To Retain"
            className="site-header-logo-img"
            width="120"
            height="32"
            fetchPriority="high"
          />
        </Link>
        <nav className="site-header-nav">
          <Link to="/blog" className="site-header-link">
            Blog
          </Link>
          <a
            href="https://tidycal.com/jeelpatel/45-minutes-meeting"
            target="_blank"
            rel="noopener noreferrer"
            className="site-header-cta"
          >
            Book Free Strategy Session
          </a>
        </nav>
        <button
          type="button"
          className="site-header-menu-btn"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`site-header-menu-icon ${open ? "is-open" : ""}`} />
        </button>
      </div>
      {open && (
        <div className="site-header-menu-panel">
          <div className="site-header-menu-panel-content">
            <Link
              to="/blog"
              className="site-header-menu-link"
              onClick={() => setOpen(false)}
            >
              Blog
            </Link>
            <a
              href="https://tidycal.com/jeelpatel/45-minutes-meeting"
              target="_blank"
              rel="noopener noreferrer"
              className="site-header-menu-cta"
              onClick={() => setOpen(false)}
            >
              Book Free Strategy Session
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;

